import { render, staticRenderFns } from "./AllegroAuthorize.vue?vue&type=template&id=b883a70c&scoped=true&"
import script from "./AllegroAuthorize.vue?vue&type=script&lang=js&"
export * from "./AllegroAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./AllegroAuthorize.vue?vue&type=style&index=0&id=b883a70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883a70c",
  null
  
)

export default component.exports